import { render } from "./SystemConfiguration.vue?vue&type=template&id=6ba7fb31&ts=true"
import script from "./SystemConfiguration.vue?vue&type=script&lang=ts"
export * from "./SystemConfiguration.vue?vue&type=script&lang=ts"

import "./SystemConfiguration.vue?vue&type=style&index=0&id=6ba7fb31&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__